export const isNil = (x:any):boolean => x == undefined || x == null;